





























































import Component from 'vue-class-component';
import LoginContainer from '@/views/authentication/login-container/LoginContainer.component';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { Prop, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import { LoginRequest } from '@/models/request/LoginRequest';
import {
  AUTH_LOADING_MODE,
  GENERATE_OTP,
  IS_RECAPTCHA_V2_USED,
  LOGIN_BY_OTP,
  OTP_SENT,
  SET_AUTH_ERRORS,
  SET_AUTH_LOADING_MODE,
  SET_OTP_SENT,
  SET_SMS_SENDING,
  SMS_SENDING,
} from '@/types/authentication.types';
import { RecaptchaNamespace } from '@/globals/recaptcha-namespace.global';
import { SmsSendingStatus } from '@/models/SmsSendingStatus';
import MockData from '@/globals/mock';
import { otpTypeSender } from '@/models/application-user/enum/otpTypeSender';

@Component({
    components: {
      LoginContainer,
    },
  })
  export default class LoginViaSmsComponent extends Vue {

    @Prop(String) public password!: string;
    @Prop(String) public siteUrl!: string;
    @Prop(String) public browserInfo!: string;
    @Prop(String) public isMobile!: string;
    @Prop(String) public gov!: string;

    @Action(LOGIN_BY_OTP, StoreNamespace.AUTHENTICATION) public loginByOtp;
    @Action(GENERATE_OTP, StoreNamespace.AUTHENTICATION) public generateOtp;

    @Mutation(SET_AUTH_ERRORS, StoreNamespace.AUTHENTICATION) public setAuthErrors;
    @Mutation(SET_OTP_SENT, StoreNamespace.AUTHENTICATION) public setOtpSent;
    @Mutation(SET_AUTH_LOADING_MODE, StoreNamespace.AUTHENTICATION) public setAuthLoadingMode;
    @Mutation(SET_SMS_SENDING, StoreNamespace.AUTHENTICATION) public setSmsSending;

    @Getter(OTP_SENT, StoreNamespace.AUTHENTICATION) public otpSent!: boolean;
    @Getter(AUTH_LOADING_MODE, StoreNamespace.AUTHENTICATION) public loadingMode!: boolean;
    @Getter(SMS_SENDING, StoreNamespace.AUTHENTICATION) public smsSending!: SmsSendingStatus;
    @Getter(IS_RECAPTCHA_V2_USED, StoreNamespace.AUTHENTICATION) public isRecaptchaV2Used!: boolean;

    private smsLoginAuth: LoginRequest = {} as LoginRequest;
    private showSuccessIcon: boolean = false;
    private SmsSendingStatus = SmsSendingStatus;
    private showReCaptcha: boolean = false;
    private showErrorIcon: boolean = false;
    private buttonText: string = '';
  public mockData: any = {};
  public otpTypeInitialValue!: number;
  public disableOtpTypeOptions: boolean = true;

    public created() {
      this.setOtpSent(false);
      this.setSmsSending(SmsSendingStatus.NOT_SENDING);
      this.buttonText = this.otpSent ? 'login.login_to_system' : 'login.sms_button_text';
      this.showReCaptcha = !!process.env.VUE_APP_RECAPTCHA_SITE_KEY;
      this.mockData = MockData;
      if (process.env.VUE_APP_OTP_TYPE == 'SMS' || process.env.VUE_APP_OTP_TYPE == 'ALL') {
        this.otpTypeInitialValue = otpTypeSender.SMS;
      } else {
        this.otpTypeInitialValue = otpTypeSender.EMAIL;
      }
      this.smsLoginAuth.otpSentType = this.otpTypeInitialValue;
      this.disableOtpTypeOptions = this.otpTypeInitialValue == otpTypeSender.SMS;
    }

    public async onLogin(recaptchaV2Response: string): Promise<void> {
      this.setSmsSending(SmsSendingStatus.NOT_SENDING);
      if (this.otpSent) {
        this.setAuthLoadingMode(true);
        this.loginByOtp({
          ...(this.isRecaptchaV2Used && { recaptchaV2Response }),
          recaptchaResponse: this.$recaptcha && await this.$recaptcha(RecaptchaNamespace.LOGIN_VIA_OTP),
          userId: Number(this.smsLoginAuth.userId),
          indexNum: Number(this.smsLoginAuth.indexNum),
          otpCode: this.smsLoginAuth.otpCode,
          otpSentType: this.smsLoginAuth.otpSentType,
        });
      } else {
        this.generateOtp({
          ...(this.isRecaptchaV2Used && { recaptchaV2Response }),
          recaptchaResponse: this.$recaptcha && await this.$recaptcha(RecaptchaNamespace.GENERATE_OTP),
          userId: Number(this.smsLoginAuth.userId),
          indexNum: Number(this.smsLoginAuth.indexNum),
          otpSentType: this.smsLoginAuth.otpSentType,
        });
      }
    }

    public async sendSmsAgain(recaptchaV2Response: string): Promise<void> {
      this.setSmsSending(SmsSendingStatus.SEND_AGAIN);
      this.setAuthLoadingMode(true);
      this.setAuthErrors([]);
      this.generateOtp({
        ...(this.isRecaptchaV2Used && { recaptchaV2Response }),
        recaptchaResponse: this.$recaptcha && await this.$recaptcha(RecaptchaNamespace.GENERATE_OTP),
        userId: Number(this.smsLoginAuth.userId),
        indexNum: Number(this.smsLoginAuth.indexNum),
        otpSentType: this.smsLoginAuth.otpSentType,
        onSendAgain: true,
      });
    }

    public onExpired() {
      // console.log('Expired')
    }

    @Watch('otpSent')
    public onOptSentChanged(val: string) {
      this.buttonText = this.otpSent ? 'login.login_to_system' : 'login.sms_button_text';
    }

  public updateOtpType(newVal: any, property: string) {
    if (property === 'otpSentType')
      this.smsLoginAuth.otpSentType = newVal;
  }

  }
